import { render } from "./ProjectEdit.vue?vue&type=template&id=22db7018"
import script from "./ProjectEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Project/ProjectEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22db7018"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22db7018', __exports__)) {
    api.reload('22db7018', __exports__)
  }
  
  module.hot.accept("./ProjectEdit.vue?vue&type=template&id=22db7018", () => {
    api.rerender('22db7018', render)
  })

}


export default __exports__